import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';

export class TypeaheadBase {
  typeaheadFormat = (value: any): string => {
    if (value == null) {
      return '';
    }

    if (typeof value === 'object' && 'name' in value) {
      const fieldValue = (value as { name?: any }).name;
      return fieldValue == null ? '' : String(fieldValue);
    }

    return String(value);
  };

  typeaheadSearch = (
    text$: Observable<string>,
    items: any[] | null | undefined | (() => any[] | null | undefined),
    limit?: number
  ): Observable<any[]> =>
    text$.pipe(map(term => this.filterTypeahead(term, this.resolveItems(items), limit)));

  private resolveItems(
    items: any[] | null | undefined | (() => any[] | null | undefined)
  ): any[] | null | undefined {
    if (typeof items === 'function') {
      return items();
    }
    return items;
  }

  private filterTypeahead(term: string, items: any[] | null | undefined, limit?: number): any[] {
    const list = Array.isArray(items) ? items : [];
    if (!term) {
      return list;
    }

    const lower = term.toLowerCase();
    const results = list.filter(item => this.typeaheadFormat(item).toLowerCase().includes(lower));

    if (limit != null) {
      return results.slice(0, limit);
    }

    return results;
  }
}
